// components/ui/EmojiPickerLazy.tsx
//
// The emoji picker, loaded client-side only.
//
// It existed twice, byte for byte: once in DoctrineView and once in SourceEmojiPicker. Same
// dynamic import, same loose prop type, same reason (the library touches `window` on import, so it
// cannot be server-rendered). Typed loosely on purpose so a caller does not couple to the
// library's strict prop types.
//
// Only the LOADER is shared. The two call sites genuinely differ in placement, in what they
// persist (a doctrine page row versus a user preference) and in their remove-button copy, so
// their popover shells stay their own.
'use client';

import React from 'react';
import dynamic from 'next/dynamic';

export const EmojiPickerLazy = dynamic(() => import('emoji-picker-react'), { ssr: false }) as unknown as React.ComponentType<{
  theme?: string;
  onEmojiClick?: (d: { emoji: string }) => void;
  previewConfig?: { showPreview?: boolean };
  lazyLoadEmojis?: boolean;
  width?: number;
  height?: number;
}>;
